module.exports = __webpack_public_path__ + "static/media/image-coach.cde74017.jpg";